import { createIcon } from '@chakra-ui/icons';

export const Splash = createIcon({
  displayName: 'Splash',
  viewBox: '0 0 16 16',
  path: [
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.55686 1.2549C6.55686 0.561839 7.1187 0 7.81177 0H8.15686C8.84993 0 9.41177 0.561839 9.41177 1.2549V14.7451C9.41177 15.4382 8.84993 16 8.15686 16H7.81177C7.1187 16 6.55686 15.4382 6.55686 14.7451V1.2549Z"
        fill="currentColor"
      />
      <path
        d="M14.7451 6.57255C15.4382 6.57255 16 7.13439 16 7.82745V8.17255C16 8.86561 15.4382 9.42745 14.7451 9.42745L1.2549 9.42745C0.561839 9.42745 -3.02948e-08 8.86561 0 8.17255L1.50847e-08 7.82745C4.53794e-08 7.13439 0.561839 6.57255 1.2549 6.57255L14.7451 6.57255Z"
        fill="currentColor"
      />
      <path
        d="M11.7754 2.23637C12.2654 1.7463 13.06 1.7463 13.5501 2.23637L13.7941 2.48039C14.2842 2.97046 14.2842 3.76502 13.7941 4.25509L4.25508 13.7941C3.76501 14.2842 2.97045 14.2842 2.48038 13.7941L2.23636 13.5501C1.74629 13.06 1.74629 12.2654 2.23636 11.7754L11.7754 2.23637Z"
        fill="currentColor"
      />
      <path
        d="M13.7941 11.7754C14.2842 12.2655 14.2842 13.06 13.7941 13.5501L13.5501 13.7941C13.06 14.2842 12.2654 14.2842 11.7754 13.7941L2.23635 4.25509C1.74629 3.76502 1.74629 2.97046 2.23635 2.48039L2.48038 2.23637C2.97045 1.7463 3.76501 1.7463 4.25508 2.23637L13.7941 11.7754Z"
        fill="currentColor"
      />
    </svg>,
  ],
});
